import { WorkflowStatusListType, ReportsView, ConfigTabs } from 'typings/enums';
import { NavigationStore } from './navigation.store';
import { ICycleNavigation } from 'typings/cycleNavigation';
import { EmployeeSort } from 'nomst/Stores/Decision/Constants/employeeSort';
import { IEmployeeViewNavigationParameters } from 'typings/navigation';

export class NavigateToNoMst {

    private _navigationStore: NavigationStore;
    constructor(nav: NavigationStore) {
        this._navigationStore = nav;
    }

    async navigateToManagerView(
        cycleId: number, workflowStatusListType: Nullable<string>, managerId: Nullable<string> = null): Promise<void> {
        this._navigationStore.navigateToTeamsView();
        this._navigationStore.decisionNavigationStore.setNavigationParamaters(
            cycleId,
            managerId ? [managerId] : undefined,
            workflowStatusListType as WorkflowStatusListType,
            null,
            ReportsView.DirectsOnly);
        return this._navigationStore.decisionNavigationStore.getManagersBasedOnWorkflowStatus();
    }

    navigateToTeamsView(cycleId: Nullable<number>, managerId: string[]): void {
        this._navigationStore.navigateToDirectTeamsView(
            cycleId,
            managerId
        );
    }

    navigateToOverBudgetManagersView(
        cycleId: number, managerSourceIds: Nullable<string[]>, budgetCycleId: number): Promise<void> {
        this._navigationStore.decisionNavigationStore.setNavigationParamaters(
            cycleId, managerSourceIds ?? [], WorkflowStatusListType.Open, budgetCycleId, ReportsView.DirectsOnly
        );
        return this._navigationStore.decisionNavigationStore.getManagersBasedOnOverBudget();
    }

    navigateToEmployeeSort(employeeSort: EmployeeSort): void {
        this._navigationStore?.navigateToUpdateState({SortBy: employeeSort} as IEmployeeViewNavigationParameters);
    }

    navToUpdatePromotionToggle(toggle: boolean): void {
        this._navigationStore?.navigateToUpdateState({PromotionFilter: toggle} as IEmployeeViewNavigationParameters);
    }

    navToUpdateSidePanel(toggle: boolean): void {
        this._navigationStore?.navigateToUpdateState({ShowSidePanel: toggle} as IEmployeeViewNavigationParameters);
    }

    navToUpdateEmployee(employee: Nullable<string>): void {
        this._navigationStore?.navigateToUpdateState({SelectedEmployee: employee} as IEmployeeViewNavigationParameters);
    }

    navigateToJobDetails(jobCode: string, jobId: string | number): void {
        this._navigationStore.goToJobDetailsView(jobCode, jobId);
    }

    navigateToEmployeeDetails(employeeSourceId: string): void {
        this._navigationStore.goToEmployeesDetailsView(employeeSourceId);
    }

    async navigateToCycleSettingsView(
        cycleId: number
    ): Promise<void> {
        return this._navigationStore.navigateToCycleSettings(cycleId);
    }

    navigateToMstWorkflowSettings(
        cycleId: number
    ): void {
        return this._navigationStore.navigateToMstWorkflowSettings(cycleId);
    }

    navigateToMstBudgetSettings(
        cycleId: number
    ): void {
        return this._navigationStore.navigateToMstBudgetSettings(cycleId);
    }

    navigateToDiagnostics(): void {
        return this._navigationStore.navigateToDiagnosticsView();
    }

    navigateToErrorMessageView(): void {
        return this._navigationStore.navigateToErrorMessageView();
    }

    navigateToConfigurationView(tab: ConfigTabs): void {
        return this._navigationStore.goToConfigurationView(tab);
    }

    navigateCycleConfigurationView(nav: ICycleNavigation): void {
        return this._navigationStore.navigateCycleConfigurationView(nav);
    }

    navigateToPromotionsView(): Promise<void> {
        return this._navigationStore.goToPromotionsView();
    }

    updateNavStore(nav: NavigationStore): void {
        this._navigationStore = nav;
    }
}